export default __webpack_public_path__ + "static/media/todo.d84d6b17.png";